import { useTranslation } from 'react-i18next';
import { useMe } from '../auth.tsx';
import { TabPanel, Tabs, useTabInUrl } from '../components/Tabs.tsx';
import { PageHeader } from '../components/ui.tsx';
import { WEB_MODULES } from '../modules/index.ts';
import { ProfileTab } from './account-profile.tsx';
import { SecurityTab } from './account-security.tsx';
import { accountTabs } from './account-tabs.ts';

/** As abas que os módulos instalados somam a Minha conta (ADR 0139). */
const MODULE_ACCOUNT_TABS = WEB_MODULES.flatMap((m) => m.accountTabs ?? []);

/**
 * Configurações do usuário: abre pelo nome da pessoa no rodapé da lateral. Em abas (ADR 0139):
 * Perfil, Segurança e as abas dos módulos. A aba aberta fica no endereço (`?tab=`).
 */
export function AccountPage() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const tabs = me ? accountTabs(MODULE_ACCOUNT_TABS, (p) => me.permissions.includes(p)) : [];
  const [tab, setTab] = useTabInUrl(
    tabs.map((x) => x.id),
    'profile',
  );
  if (!me) return null;
  const Module = tabs.find((x) => x.id === tab)?.component;
  return (
    <div className="flex max-w-3xl flex-col gap-6">
      <PageHeader title={t('account.title')} description={t('account.description')} />
      <Tabs
        items={tabs.map((x) => ({ id: x.id, label: t(x.labelKey) }))}
        value={tab}
        onChange={setTab}
        label={t('account.tabs.label')}
        idPrefix="account"
      />
      <TabPanel idPrefix="account" id={tab}>
        {tab === 'profile' && <ProfileTab name={me.user.displayName} email={me.user.email} />}
        {tab === 'security' && <SecurityTab permissions={me.permissions} />}
        {Module && <Module />}
      </TabPanel>
    </div>
  );
}
